// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__3j-Wy","ThumbZoom":"ChapterPlayer_ThumbZoom__3BuJ7"};